import type { SupportedLanguage } from "../locales";

type HomeFaqHeading = {
  title: string;
  subtitle: string;
};

const homeFaqHeadingByLanguage: Record<SupportedLanguage, HomeFaqHeading> = {
  en: {
    title: "AI Dubbing & Video Translation FAQ for Creators",
    subtitle:
      "Everything you need to know about Vevi Dubbing Monster, AI voice replacement, lip-sync, and multilingual Shorts",
  },
  ru: {
    title: "FAQ по AI-дубляжу и переводу видео для авторов",
    subtitle:
      "Всё, что нужно знать о Vevi Dubbing Monster, AI-замене голоса, lip-sync и многоязычных Shorts",
  },
  es: {
    title: "FAQ de doblaje con IA y traducción de video para creadores",
    subtitle:
      "Todo lo que necesitas saber sobre Vevi Dubbing Monster, el reemplazo de voz con IA, el lip-sync y los Shorts multilingües",
  },
  fr: {
    title: "FAQ sur le doublage IA et la traduction vidéo pour les créateurs",
    subtitle:
      "Tout ce qu'il faut savoir sur Vevi Dubbing Monster, le remplacement de voix par IA, le lip-sync et les Shorts multilingues",
  },
  de: {
    title: "FAQ zu KI-Dubbing und Videoübersetzung für Creator",
    subtitle:
      "Alles, was du über Vevi Dubbing Monster, KI-Voice-Replacement, Lip-Sync und mehrsprachige Shorts wissen musst",
  },
  it: {
    title: "FAQ su doppiaggio AI e traduzione video per creator",
    subtitle:
      "Tutto quello che devi sapere su Vevi Dubbing Monster, sostituzione vocale con AI, lip-sync e Shorts multilingue",
  },
  pt: {
    title: "FAQ sobre dublagem com IA e tradução de vídeo para criadores",
    subtitle:
      "Tudo o que você precisa saber sobre Vevi Dubbing Monster, substituição de voz com IA, lip-sync e Shorts multilíngues",
  },
  pl: {
    title: "FAQ o dubbingu AI i tłumaczeniu wideo dla twórców",
    subtitle:
      "Wszystko, co warto wiedzieć o Vevi Dubbing Monster, podmianie głosu AI, lip-syncu i wielojęzycznych Shortsach",
  },
  zh: {
    title: "面向创作者的 AI 配音与视频翻译 FAQ",
    subtitle:
      "关于 Vevi Dubbing Monster、AI 声音替换、口型同步和多语言 Shorts，你需要知道的一切",
  },
  ja: {
    title: "クリエイター向け AI吹き替え・動画翻訳 FAQ",
    subtitle:
      "Vevi Dubbing Monster、AI音声置き換え、リップシンク、多言語Shortsについて知っておきたいことをまとめました",
  },
  ko: {
    title: "크리에이터를 위한 AI 더빙 및 영상 번역 FAQ",
    subtitle:
      "Vevi Dubbing Monster, AI 음성 교체, 립싱크, 다국어 Shorts에 대해 꼭 알아야 할 모든 내용",
  },
  ar: {
    title: "الأسئلة الشائعة حول الدبلجة بالذكاء الاصطناعي وترجمة الفيديو للمبدعين",
    subtitle:
      "كل ما تحتاج إلى معرفته عن Vevi Dubbing Monster واستبدال الصوت بالذكاء الاصطناعي وlip-sync وShorts متعددة اللغات",
  },
  bg: {
    title: "FAQ за AI дублаж и видео превод за създатели",
    subtitle:
      "Всичко, което трябва да знаете за Vevi Dubbing Monster, AI смяна на глас, lip-sync и многоезични Shorts",
  },
  hr: {
    title: "FAQ o AI sinkronizaciji i prijevodu videa za kreatore",
    subtitle:
      "Sve što trebate znati o Vevi Dubbing Monsteru, AI zamjeni glasa, lip-syncu i višejezičnim Shortsima",
  },
  cs: {
    title: "FAQ o AI dabingu a překladu videa pro tvůrce",
    subtitle:
      "Vše, co potřebujete vědět o Vevi Dubbing Monster, AI náhradě hlasu, lip-syncu a vícejazyčných Shorts",
  },
  da: {
    title: "FAQ om AI-dubbing og videooversættelse til skabere",
    subtitle:
      "Alt, du skal vide om Vevi Dubbing Monster, AI-stemmeerstatning, lip-sync og flersprogede Shorts",
  },
  nl: {
    title: "FAQ over AI-dubbing en videovertaling voor creators",
    subtitle:
      "Alles wat je moet weten over Vevi Dubbing Monster, AI-stemvervanging, lip-sync en meertalige Shorts",
  },
  et: {
    title: "KKK AI-dubleerimise ja videotõlke kohta loojatele",
    subtitle:
      "Kõik, mida pead teadma Vevi Dubbing Monsteri, AI-häälevahetuse, lip-sync'i ja mitmekeelsete Shortside kohta",
  },
  fi: {
    title: "UKK: AI-dubbaus ja videokäännös tekijöille",
    subtitle:
      "Kaikki, mitä sinun tarvitsee tietää Vevi Dubbing Monsterista, AI-äänenvaihdosta, lip-syncistä ja monikielisistä Shortseista",
  },
  el: {
    title: "Συχνές ερωτήσεις για AI dubbing και μετάφραση βίντεο για δημιουργούς",
    subtitle:
      "Όλα όσα πρέπει να γνωρίζετε για το Vevi Dubbing Monster, την αντικατάσταση φωνής με AI, το lip-sync και τα πολύγλωσσα Shorts",
  },
  hu: {
    title: "GYIK az AI dubbingról és videófordításról alkotóknak",
    subtitle:
      "Minden, amit tudnod érdemes a Vevi Dubbing Monsterről, az AI hangcseréről, a lip-syncről és a többnyelvű Shortokról",
  },
  ga: {
    title: "CCG faoi dhubáil AI agus aistriú físe do chruthaitheoirí",
    subtitle:
      "Gach rud ba chóir duit a bheith ar eolas faoi Vevi Dubbing Monster, athsholáthar gutha AI, lip-sync agus Shorts ilteangacha",
  },
  lv: {
    title: "BUJ par AI dublēšanu un video tulkošanu veidotājiem",
    subtitle:
      "Viss, kas jāzina par Vevi Dubbing Monster, AI balss nomaiņu, lip-sync un daudzvalodu Shorts",
  },
  lt: {
    title: "DUK apie AI dubliavimą ir vaizdo vertimą kūrėjams",
    subtitle:
      "Viskas, ką reikia žinoti apie Vevi Dubbing Monster, AI balso pakeitimą, lip-sync ir daugiakalbius Shorts",
  },
  mt: {
    title: "FAQ dwar dubbing bl-AI u traduzzjoni tal-vidjo għall-ħallieqa",
    subtitle:
      "Dak kollu li għandek bżonn tkun taf dwar Vevi Dubbing Monster, sostituzzjoni tal-vuċi bl-AI, lip-sync u Shorts multilingwi",
  },
  ro: {
    title: "Întrebări frecvente despre dublaj AI și traducere video pentru creatori",
    subtitle:
      "Tot ce trebuie să știi despre Vevi Dubbing Monster, înlocuirea vocii cu AI, lip-sync și Shorts multilingve",
  },
  sk: {
    title: "FAQ o AI dabingu a preklade videa pre tvorcov",
    subtitle:
      "Všetko, čo potrebujete vedieť o Vevi Dubbing Monster, AI výmene hlasu, lip-syncu a viacjazyčných Shorts",
  },
  sl: {
    title: "Pogosta vprašanja o AI dubbingu in prevajanju videa za ustvarjalce",
    subtitle:
      "Vse, kar morate vedeti o Vevi Dubbing Monster, AI zamenjavi glasu, lip-syncu in večjezičnih Shorts",
  },
  sv: {
    title: "Vanliga frågor om AI-dubbning och videoöversättning för skapare",
    subtitle:
      "Allt du behöver veta om Vevi Dubbing Monster, AI-röstbyte, lip-sync och flerspråkiga Shorts",
  },
};

export function getHomeFaqHeading(language: SupportedLanguage): HomeFaqHeading {
  return homeFaqHeadingByLanguage[language] || homeFaqHeadingByLanguage.en;
}
